export const ActionTypes = {
  FETCH_VISION_OLE:
    'services/dashboards/vision/visionOLEDashboard/fetch_vision_ole',
  SET_VISION_OLE:
    'services/dashboards/vision/visionOLEDashboard/set_vision_ole',
  SET_LOADER_STATUS:
    'services/dashboards/vision/visionOLEDashboard/set_loader_status',
};

const fetchVisionOle = () => ({
  type: ActionTypes.FETCH_VISION_OLE,
});

const setVisionOle = ({ visionOLEData }) => ({
  visionOLEData,
  type: ActionTypes.SET_VISION_OLE,
});
const setLoader = ({ showLoader }) => ({
  showLoader,
  type: ActionTypes.SET_LOADER_STATUS,
});

export default {
  fetchVisionOle,
  setVisionOle,
  setLoader,
};
